// extracted by css-extract-rspack-plugin
export default {"message":"message-bD3d4D","requestId":"requestId-ruNa4F"};